import { API_BASE_URL } from '../Utils/constants';
import { authFetch } from './authFetch';

// El Bearer (renovado, sin `Bearer null`, reintento ante 401) lo pone `authFetch`.
const getHeaders = () => ({
  'Content-Type': 'application/json',
});

export const trackLotView = async ({ lot_id }) => {
  const response = await authFetch(`${API_BASE_URL}/tracklotview`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify({ lot_id }),
  });

  let json = null;
  try {
    json = await response.json();
  } catch {
    json = {};
  }

  return {
    ...json,
    _httpStatus: response.status,
    _httpOk: response.ok,
  };
};

/** @param {{ limit?: number, signal?: AbortSignal }} [options] */
export const getLotHistory = async ({ limit = 20, signal } = {}) => {
  const safeLimit = Math.max(1, Math.min(Number(limit) || 20, 50));
  const response = await authFetch(`${API_BASE_URL}/getlothistory?limit=${encodeURIComponent(safeLimit)}`, {
    method: 'GET',
    headers: getHeaders(),
    signal,
  });

  let json = null;
  try {
    json = await response.json();
  } catch {
    json = {};
  }

  return {
    ...json,
    _httpStatus: response.status,
    _httpOk: response.ok,
  };
};

